import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RevokeEnrollmentPacketMutation = graphql.persisted(
  "RevokeEnrollmentPacket",
  graphql(`
    mutation RevokeEnrollmentPacket($familyEnrollmentId: ID!) {
      revokeEnrollmentPacket(input: { familyEnrollmentId: $familyEnrollmentId }) {
        familyEnrollment { id state inviteToken packetSentAt packetViewedAt packetSubmittedAt }
        userErrors { message path }
      }
    }
  `)
);

export { RevokeEnrollmentPacketMutation };

export function useRevokeEnrollmentPacket() {
  return useMutation(RevokeEnrollmentPacketMutation);
}
